module.exports = __webpack_public_path__ + "img/Ecorodovias.0ebe665-1.2.11.png";